import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Sparkles, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BoostSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/boost/status/${sessionId}`);
        setDetails(data);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.status === "expired") { setStatus("error"); return; }
        attempts += 1;
        if (attempts >= 8) { setStatus("pending"); return; }
        setTimeout(poll, 2000);
      } catch {
        attempts += 1;
        if (attempts >= 8) { setStatus("error"); return; }
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      {status === "checking" && (
        <>
          <Loader2 className="w-12 h-12 text-orange-500 mx-auto animate-spin" />
          <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tighter">Activating boost…</h1>
        </>
      )}
      {status === "paid" && (
        <>
          <Sparkles className="w-16 h-16 text-orange-500 mx-auto" />
          <h1 data-testid="boost-success" className="mt-6 font-display text-5xl font-black uppercase tracking-tighter text-white">Your listing is now Featured.</h1>
          <p className="mt-4 text-zinc-400 max-w-md mx-auto">
            It&apos;s pinned to the top of Browse and Home for the next 7 days. Expect a spike in views and bids.
          </p>
          <Button asChild className="mt-8 rounded-none bg-orange-600 hover:bg-orange-500 border border-orange-500 h-12 px-8 text-sm uppercase tracking-widest font-semibold">
            <Link to="/dashboard/selling">View My Listings</Link>
          </Button>
        </>
      )}
      {status === "pending" && (
        <>
          <Loader2 className="w-12 h-12 text-orange-500 mx-auto" />
          <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tighter">Still Processing…</h1>
          <Button asChild className="mt-8 rounded-none bg-orange-600 hover:bg-orange-500 border border-orange-500 h-12 px-8">
            <Link to="/dashboard/selling">Back to Listings</Link>
          </Button>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle className="w-16 h-16 text-red-500 mx-auto" />
          <h1 className="mt-6 font-display text-4xl font-black uppercase tracking-tighter">Boost Failed</h1>
          <Button asChild className="mt-8 rounded-none bg-orange-600 hover:bg-orange-500 border border-orange-500 h-12 px-8">
            <Link to="/dashboard">Back to Dashboard</Link>
          </Button>
        </>
      )}
    </div>
  );
}
